import { restApi } from '~features/api/restApiSlice';
import { AGGREGATED_METRICS_API_SHARED_SETTINGS } from '~features/api/aggregatedMetricsApiSettings';
import { type CrawlerCategoryScheme, categorizeCrawlersList } from './Crawlers';

export const CRAWLERS_LIST_ENDPOINT = '/v4/aggregated-metrics/crawlers';

const crawlerFilterApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    getCrawlersFiltersList: builder.query<string[], { domain?: string; categoryScheme: CrawlerCategoryScheme }>({
      ...AGGREGATED_METRICS_API_SHARED_SETTINGS,
      query: ({ domain }) => {
        const params: Record<string, string> = {};
        if (domain) params['domain'] = domain;

        return { url: CRAWLERS_LIST_ENDPOINT, params };
      },
      transformResponse: (response: { data: string[] }, _meta, arg) =>
        categorizeCrawlersList(response.data, arg.categoryScheme),
    }),
  }),
});

export const { useGetCrawlersFiltersListQuery } = crawlerFilterApi;
